import React from "react";
import { Link } from "react-router-dom";
import "./Blog3.css";
import Footer from "./Footer";
import blogicon from "../assets/blogicon.png";
import blogicon1 from "../assets/blogicon1.png";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import API_CONFIG from "../config/api";

const Blog3 = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="blog-page-wrapper">
        <section className="blog-top-section">
          <h1 className="blogs-header-title">
            <span className="explore-featured">Explore Our Featured</span>{" "}
            <span className="blog-posts-color">Blog Posts</span>
          </h1>
          <p className="blogs-header-desc">
            Explore our featured blog, a hub of inspiring stories, expert
            insights, and innovative ideas designed to spark curiosity and build
            confidence in young minds through STEM and tech learning. From the
            latest trends in education to practical project guides, we cover
            everything parents and educators need to nurture future-ready
            skills.
          </p>
          <div className="blog-header-images">
            <img src={blogicon} alt="Blog Icon Left" className="blog-icon-left" />
            <img src={blogicon1} alt="Blog Icon Right" className="blog-icon-right" />
          </div>
        </section>
      </div>

      <div className="blog3-page">
        <div className="blog3-container">
          <Link to="/blogs" className="back-to-blogs">
            <span className="back-arrow">&larr;</span> Back to Blogs
          </Link>

          <article className="blog3-article">
            <header className="blog3-header">
              <div className="blog-breadcrumb">
                <span>Home</span> / <span>Blogs</span> / <span>Study Tips</span>
              </div>
              <h1>How to manage your time while online learning</h1>
              <div className="blog3-meta">
                <span className="blog3-date">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#9c2e8a" strokeWidth="2" />
                    <path d="M12 6V12L16 14" stroke="#9c2e8a" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                  10 April 2025
                </span>
                <span className="blog3-author">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#5a5252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#5a5252" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  By Polymath Kids
                </span>
                <span className="blog3-read-time">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6V12L16 14" stroke="#5a5252" strokeWidth="2" strokeLinecap="round" />
                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3" stroke="#5a5252" strokeWidth="2" />
                  </svg>
                  6 min read
                </span>
              </div>
              <div className="blog3-image">
                <img src={`${API_CONFIG.IMAGES_URL}/Polymath-images/Blog_images/6.png`} alt="Student managing time during online learning" />
                <div className="image-caption">Effective time management leads to successful online learning</div>
              </div>
            </header>

            <div className="blog3-content">
              <div className="content-intro">
                <p className="blog3-intro">
                  Ever found yourself spending hours on a task that should've taken minutes? Or
                  procrastinating till the deadline is dangerously close? Like no matter how hard you
                  try, still everything feels overwhelming and there's just no clear way forward? If
                  that sounds like you then you're in the right place.
                </p>

                <p className="blog3-intro">
                  This blog is written to guide you on how to manage your time effectively while learning online so you can stay
                  focused, feel less stressed, and actually get things done.
                </p>
              </div>

              <div className="blog3-divider"></div>

              <h2>1. Don't leave everything for the last day</h2>
              <p>
                When you're learning online, it often feels like you have a lot of time. That's
                why it is so easy to keep putting things off, telling yourself you'll do it later until
                suddenly, the deadline is just a day away. This mindset can make things pile up
                and leave you feeling even more overwhelmed.
              </p>

              <div className="info-box">
                <div className="info-box-icon">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#812470" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="info-box-content">
                  <h3>Why procrastination hurts online learning:</h3>
                  <ul>
                    <li>Creates unnecessary stress and anxiety</li>
                    <li>Reduces the quality of your work</li>
                    <li>Prevents deep learning and understanding</li>
                    <li>Makes it harder to ask for help when needed</li>
                  </ul>
                </div>
              </div>

              <p>
                One of the biggest mistakes is waiting until the last minute when you are
                thinking you'll somehow manage to finish it all in one go. But the truth is when
                you're learning online, you're the one in charge of your progress. That means
                it's your responsibility to stay on track.
              </p>

              <p>
                Try to cover your tasks bit by bit instead of saving everything for the end. Not
                only will this help you stay relaxed and avoid last minute stress but it'll also
                give you a sense of achievement as you go. Staying ahead of deadlines brings
                peace of mind, and that alone makes a big difference.
              </p>

              <div className="blog3-divider"></div>

              <h2>2. Make a clear schedule, and stick to it</h2>
              <p>
                One of the biggest reasons people struggle with managing their time during
                online learning is that they don't have a clear plan for the day. Without a
                schedule, it's easy to waste time or get distracted, thinking you'll "figure it out
                later." But time slips away fast and suddenly the day is gone.
              </p>

              <p>
                That's why it's so important to start your day with a solid plan. Write down
                exactly what you need to get done and make a strong commitment to yourself
                that "I'm going to complete these tasks today no matter what."
              </p>

              <div className="numbered-tips">
                <div className="tip-item">
                  <div className="tip-number">1</div>
                  <div className="tip-content">
                    <h3>Be strict with your schedule</h3>
                    <p>
                      Tell yourself: "I won't do this until I finish that."
                      Sometimes that means saying no to other things or even setting small
                      punishments for not sticking to the plan. It may sound tough but it builds
                      discipline, and it's important for you to get on the right track.
                    </p>
                  </div>
                </div>

                <div className="tip-item">
                  <div className="tip-number">2</div>
                  <div className="tip-content">
                    <h3>Celebrate your achievements</h3>
                    <p>
                      Once you do complete the task that you've planned, celebrate it! Give
                      yourself a small reward. Whether it's watching your favourite show, a snack
                      you love or just a break, celebrating your achievements makes the process
                      more motivating.
                    </p>
                  </div>
                </div>
              </div>

              <p>
                This simple routine of planning, committing, and rewarding can completely
                change the way you manage your time and help you stay ahead not behind.
              </p>

              <div className="blog3-divider"></div>

              <h2>3. Keep everything organized</h2>
              <p>
                Headaches during online learning are often caused by a lack of a
                proper setup. When you don't have a clean, organized space, when your
                laptop isn't ready and you constantly have to get up to find or prepare things, it
                leads to distraction and frustration.
              </p>

              <div className="blog3-divider"></div>

              <h2>4. Save the screen time for last (protect your focus and energy)</h2>
              <p>
                One of the biggest ways we waste time is by immediately going
                to our phones after working. For example even if you give a full, focused
                hour to maths, you might pick up your phone afterward and start scrolling.
                You think, "I've done my work, I deserve this," but without realizing it you
                still end up wasting more time than you planned.
              </p>

              <div className="myth-reality-container">
                <div className="myth-reality-item">
                  <div className="myth-section">
                    <h3>Common Mistake</h3>
                    <p>Using screen time as an immediate reward after studying</p>
                  </div>
                  <div className="reality-section">
                    <h3>Reality</h3>
                    <p>Schedule screen time after completing all planned tasks for the day</p>
                  </div>
                </div>
              </div>

              <p>
                Yes, taking a break is important, but it's better if that break refreshes your mind.
                Talk to someone, step outside or do something that makes you feel better and
                sharpens your brain. Mindless scrolling through reels often drains your energy and
                makes it harder to focus again.
              </p>

              <p>
                That's why it is best to schedule your screen time after completing the tasks
                you've planned for the day, even if they are small. Giving screen time first can lead
                to distractions, headaches and frustration. It's much healthier to manage your day
                first and then reward yourself with screen time at the end. This helps you stay in
                control of your time and energy.
              </p>

              <div className="blog3-divider"></div>

              <h2>Find Your Why</h2>
              <p>
                In the end, if you have a clear goal and you truly understand why you need to do
                something, why it matters, and why it must be done on time, then nothing can
                stop you. Distractions fade when your purpose is strong.
              </p>

              <div className="blog3-conclusion">
                <p>
                  So find your why and take each step wholeheartedly, and stick to it. When your
                  efforts are driven by purpose, procrastination loses its power. You'll find it easier
                  to manage your time, stay focused, and achieve what you set out to do.
                </p>
              </div>
            </div>

            <div className="blog-navigation">
              <div className="nav-previous">
                <span>Previous Article</span>
                <h4>Why Online Summer Camps are Important for 21st-Century Kids</h4>
              </div>
              <div className="nav-next">
                <span>Next Article</span>
                <h4>How to Prepare for Your First Coding Competition</h4>
              </div>
            </div>
          </article>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog3;